// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2Qoqx","description":"PatientConsentPreview_description__1a5FT"};